// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ODvDC","option":"styles_option__1MpXK","active":"styles_active__yY_1d"};